import React, { FC, useContext, useMemo, useState } from 'react';

import FormulaEditorToolbarIcon from '../../assistant/components/FormulaEditorToolbarIcon';

//constants
import ICONS from '../../../../../constants/icons';

import { EditorContext } from '../../../../../context/EditorContext';

//models
import { CompoundTriggerType } from '../../../../../models/compound-trigger.model';

//components
import CMSPlaceholderMainModal from './CMSPlaceholderMainModal';

interface CMSPlaceholderMainProps {
    isEditable: boolean;
}

const CMSPlaceholderMain: FC<CMSPlaceholderMainProps> = ({ isEditable }) => {
    const {
        editorDetails: { formula },
    } = useContext(EditorContext);
    const [showCMSPlaceholderModal, setShowCMSPlaceholderModalModal] =
        useState<boolean>(false);

    const isDisableIcon = useMemo(
        () =>
            [
                CompoundTriggerType.SEND_IMMEDIATELY,
                CompoundTriggerType.SEND_WITH_DELAY,
            ].includes(
                formula?.compound_trigger?.trigger_type ??
                    CompoundTriggerType.AAMPE_OPTIMISED,
            ),
        [formula?.compound_trigger?.trigger_type],
    );

    return (
        <>
            <FormulaEditorToolbarIcon
                isDisabled={!formula?.id! || isDisableIcon}
                Icon={ICONS.cmsPlaceHolder}
                title="Select CMS type"
                onIconClick={() => setShowCMSPlaceholderModalModal(true)}
            />
            {showCMSPlaceholderModal && (
                <CMSPlaceholderMainModal
                    isEditable={isEditable}
                    handleClose={() => setShowCMSPlaceholderModalModal(false)}
                />
            )}
        </>
    );
};

export default CMSPlaceholderMain;
